module.exports = __webpack_public_path__ + "media/images/Playicon-4730dea2.png";